import { apiGet, apiPost } from '../../../adapters/api-client/api';

export type BookingState =
  | 'Requested'
  | 'Confirmed'
  | 'Rescheduled'
  | 'Cancelled'
  | 'Completed'
  | 'NoShow';

export interface Booking {
  bookingId: string;
  enrollmentId: string;
  milestoneSequence: number;
  state: BookingState;
  scheduledStart?: string;
  scheduledEnd?: string;
  requestedBy?: 'parent' | 'teacher';
  confirmedAt?: string;
  cancelledAt?: string;
  cancelledBy?: 'parent' | 'teacher';
  cancellationReason?: string;
  proposedStart?: string;
  proposedEnd?: string;
  rescheduleProposedBy?: 'parent' | 'teacher';
  priorStart?: string;
  priorEnd?: string;
  parentId: string;
  teacherId: string;
  childId: string;
  courseId: string;
  courseTitle?: string;
  childFirstName?: string;
}

export interface AvailableWindow {
  start: string;
  end: string;
  timezone: string;
}

export function getBookings(enrollmentId: string): Promise<{ bookings: Booking[] }> {
  return apiGet(`/api/v1/bookings/enrollment/${enrollmentId}`);
}

export function getAvailableWindows(
  enrollmentId: string,
  from: string,
  to: string,
): Promise<{ teacherId: string; windows: AvailableWindow[] }> {
  const params = new URLSearchParams({ from, to });
  return apiGet(
    `/api/v1/bookings/enrollment/${enrollmentId}/available-windows?${params.toString()}`,
  );
}

export function requestBooking(input: {
  enrollmentId: string;
  milestoneSequence: number;
  scheduledStart: string;
  scheduledEnd: string;
}): Promise<{ booking: Booking }> {
  return apiPost('/api/v1/bookings/request', input);
}

export function confirmBooking(bookingId: string): Promise<{ booking: Booking }> {
  return apiPost(`/api/v1/bookings/${bookingId}/confirm`, {});
}

export function rescheduleBooking(
  bookingId: string,
  newStart: string,
  newEnd: string,
): Promise<{ booking: Booking }> {
  return apiPost(`/api/v1/bookings/${bookingId}/reschedule`, { newStart, newEnd });
}

export function acceptReschedule(bookingId: string): Promise<{ booking: Booking }> {
  return apiPost(`/api/v1/bookings/${bookingId}/accept-reschedule`, {});
}

export function cancelBooking(bookingId: string, reason?: string): Promise<{ booking: Booking }> {
  return apiPost(`/api/v1/bookings/${bookingId}/cancel`, { reason });
}
